export default "__VITE_ASSET__6fkiXlQx__"